/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from 'react-toastify';
import { call, put, takeLatest } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import {
	IDownloadDocumentRequest,
	IDocumentDownloadPDF,
	IDownloadCsvRequest,
	IDocumentDownloadCSV,
} from 'app/interfaces/document-download/document-download.interface';
import apiRequest from '../api/api.request';
import { ApiRequestConfig } from '../../interfaces/api-request/api.interface';
import { setGlobalLoaderAction } from '../actions/CommonAction';
import endpoints from '../../../constants/endpoints';
import {
	failedFundingAction,
	generatePrivyFundingAction,
	IPrivyFundingResponse,
	ISubmitFundingPayload,
	resetFundingStateAction,
	submitFundingAction,
	successFundingAction,
	getLoanAgreementDocumentAction,
	setLoanAgreementDocumentAction,
	resetLoanAgreementDocumentAction,
	IAgreementDocumentRequest,
	IAgreementDocumentResponse,
	setErrorAgreement,
	downloadAgrementPDFAction,
	setAgreementPDFAction,
	resetAgreementPDFAction,
	ISubmitBulkFundingPayload,
	submitBulkFundingAction,
	successBulkFundingAction,
	setLenderAgreementPDFAction,
	downloadLenderAgrementPDFAction,
	setTransactionHistoryCsvAction,
	downloadTransactionHistoryCsvAction,
} from '../actions/FundingAction';

function* submitFunding({
	payload,
}: {
	payload: ISubmitFundingPayload;
}): Generator {
	yield put(setGlobalLoaderAction(true));
	const auth = JSON.parse(localStorage.getItem('user') as string);
	const body = {
		loanInfo: [
			{
				loanId: payload.loanId,
				amount: payload.amount,
			},
		],
	};
	const config: ApiRequestConfig = {
		path: endpoints.api.FUNDING,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${auth.token}`,
		},
		query: null,
		body,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(generatePrivyFundingAction(data));
	} catch (err) {
		yield put(failedFundingAction({ error: err as string }));
	}
}

function* generatePrivy({
	payload,
}: {
	payload: IPrivyFundingResponse;
}): Generator {
	yield put(setGlobalLoaderAction(false));
	return payload;
}

function* successFunding({
	payload,
}: {
	payload: ISubmitFundingPayload;
}): Generator {
	try {
		return payload;
	} catch (err) {
		yield put(failedFundingAction({ error: 'Error' }));
		return payload;
	}
}

function resetFunding({ payload }: { payload: boolean }): boolean {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* fetchLoanAgreementDocument({
	payload,
}: {
	payload: IAgreementDocumentRequest;
}): Generator {
	const userData = localStorage.getItem('user');
	let userToken = '';
	if (userData) {
		const resp = JSON.parse(userData);
		userToken = resp.token;
	}
	const config: ApiRequestConfig = {
		path: endpoints.api.AGREEMENT,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
		},
		query: null,
		body: payload,
		timeout: 0,
		responseType: 'json',
	};
	try {
		const res = yield call(apiRequest, config);
		const { data } = res as any;
		yield put(setLoanAgreementDocumentAction(data));
		return res;
	} catch (err) {
		yield put(setErrorAgreement(err as string));
		return err;
	}
}

function* downloadDocumentPDFSaga({
	payload,
}: {
	payload: IDownloadDocumentRequest;
}): Generator {
	const userData = localStorage.getItem('user');
	let userToken = '';
	if (userData) {
		const resp = JSON.parse(userData);
		userToken = resp.token;
	}
	// const auth = `${environment.authUsername}:${environment.authPassword}`;
	const config: ApiRequestConfig = {
		path: endpoints.api.DOWNLOAD_DOCUMENT,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
		},
		query: null,
		body: payload,
		timeout: 0,
		responseType: 'arraybuffer', // ini adalah kunci
	};
	try {
		const resp = yield call(apiRequest, config);
		const type = 'application/pdf';
		const blobResult = new Blob([new Uint8Array(resp as any)], { type });

		yield put(setAgreementPDFAction({ base64PDF: blobResult }));
	} catch (err) {
		// return payload;
	}
}

function* downloadLenderDocumentPDFSaga({
	payload,
}: {
	payload: IDownloadDocumentRequest;
}): Generator {
	const userData = localStorage.getItem('user');
	let userToken = '';
	if (userData) {
		const resp = JSON.parse(userData);
		userToken = resp.token;
	}
	const config: ApiRequestConfig = {
		path: endpoints.api.DOWNLOAD_DOCUMENT,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${userToken}`,
		},
		query: null,
		body: payload,
		timeout: 0,
		responseType: 'arraybuffer',
	};
	try {
		const resp = yield call(apiRequest, config);
		const type = 'application/pdf';
		const blobResult = new Blob([new Uint8Array(resp as any)], { type });

		yield put(setLenderAgreementPDFAction({ base64PDF: blobResult }));
	} catch (err) {
		// return payload;
	}
}

function* downloadDocumentCsvSaga({
	payload,
}: {
	payload: IDownloadCsvRequest;
}): Generator {
	const auth = JSON.parse(JSON.stringify(localStorage.getItem('user')));
	const config: ApiRequestConfig = {
		path: endpoints.api.TRANSACTION_HISTORY_CSV,
		method: 'GET',
		headers: {
			Authorization: `Bearer ${JSON.parse(auth).token}`,
			'X-Authenticated-Userid': `${JSON.parse(auth).userId}`,
		},
		query: payload,
		body: null,
		timeout: 0,
		responseType: 'arraybuffer', // ini adalah kunci
	};
	try {
		const resp = yield call(apiRequest, config);
		const type = 'text.csv';
		const blobResult = new Blob([new Uint8Array(resp as any)], { type });
		yield put(
			setTransactionHistoryCsvAction({
				transactionNumber: payload.bulkFundingNumber,
				base64CSV: blobResult,
			})
		);
	} catch (err) {
		// return payload;
	}
}

function setLoanAgreementDocumentSaga({
	payload,
}: {
	payload: IAgreementDocumentResponse;
}): IAgreementDocumentResponse | unknown {
	try {
		return payload;
	} catch (err) {
		return err;
	}
}

function setAgreementPDFSaga({
	payload,
}: {
	payload: IDocumentDownloadPDF;
}): IDocumentDownloadPDF {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function setTransactionHistoryCsvSaga({
	payload,
}: {
	payload: IDocumentDownloadCSV;
}): IDocumentDownloadCSV | unknown {
	try {
		return payload;
	} catch (err) {
		// TODO: error handler
		return err;
	}
}

function errorAgreement({ payload }: { payload: string }): string {
	toast.error('Mohon maaf terjadi kesalahan. Coba beberapa saat lagi.');
	return payload;
}

function resetAgreementDocumentSaga({
	payload,
}: {
	payload;
}): IDocumentDownloadPDF {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function resetAgreementPDFSaga({ payload }: { payload }): IDocumentDownloadPDF {
	try {
		return payload;
	} catch (err) {
		return payload;
	}
}

function* submitBulkFunding({
	payload,
}: {
	payload: ISubmitBulkFundingPayload;
}): Generator {
	yield put(setGlobalLoaderAction(true));
	const auth = JSON.parse(localStorage.getItem('user') as string);
	const body = {
		loan_type_secure_id: payload.loan_type_secure_id,
		loan_bulk_upload_group_id: payload.loan_bulk_upload_group_id,
	};
	const config: ApiRequestConfig = {
		path: endpoints.api.SUBMIT_BULK_FUNDING,
		method: 'POST',
		headers: {
			Authorization: `Bearer ${auth.token}`,
			'X-REQUEST-ID': uuidv4(),
			platform: 'Web',
		},
		query: null,
		body,
		timeout: 0,
	};
	try {
		const res = yield call(apiRequest, config);
		const { message } = res as any;
		if (message) {
			yield put(successBulkFundingAction(true));
			yield put(setGlobalLoaderAction(false));
		}
	} catch (err) {
		toast.error(err as string);
		yield put(setGlobalLoaderAction(false));
		yield put(failedFundingAction({ error: err as string }));
	}
}

export default function* FundingSaga(): Generator {
	yield takeLatest(submitFundingAction, submitFunding);
	yield takeLatest(generatePrivyFundingAction, generatePrivy);
	yield takeLatest(successFundingAction, successFunding);
	yield takeLatest(resetFundingStateAction, resetFunding);
	yield takeLatest(
		getLoanAgreementDocumentAction,
		fetchLoanAgreementDocument
	);
	yield takeLatest(
		setLoanAgreementDocumentAction,
		setLoanAgreementDocumentSaga
	);
	yield takeLatest(setErrorAgreement, errorAgreement);
	yield takeLatest(
		resetLoanAgreementDocumentAction,
		resetAgreementDocumentSaga
	);
	yield takeLatest(downloadAgrementPDFAction, downloadDocumentPDFSaga);
	yield takeLatest(setAgreementPDFAction, setAgreementPDFSaga);
	yield takeLatest(resetAgreementPDFAction, resetAgreementPDFSaga);
	yield takeLatest(submitBulkFundingAction, submitBulkFunding);
	yield takeLatest(
		downloadLenderAgrementPDFAction,
		downloadLenderDocumentPDFSaga
	);
	yield takeLatest(
		downloadTransactionHistoryCsvAction,
		downloadDocumentCsvSaga
	);
	yield takeLatest(
		setTransactionHistoryCsvAction,
		setTransactionHistoryCsvSaga
	);
}
